module.exports = __webpack_public_path__ + "img/cadastro.a3bab171.jpg";